<template>

	<!-- 物流包装 -->
	<div class="Minister-top information">
		<div class="Minister-top-top Ministerbackground">
			<div class="Minister-top-left Minister-top-color">物流包装</div>
		</div>
		<div class="information_content">
			<div class="information_input" style="margin-bottom:20px;" >
				<div class="information_Title">
					<span class="tips">*</span>
					仓库
				</div>
				<div class="input_el input_span">
					<div class="newipt">
						<el-select
								ref="customTextarea"
								v-model="formData.warehouseId"
								class="width67 "
								placeholder="请选择店铺后再选择店铺"
								@change="selectChange"
								:disabled="system < 5 || isChakan"
								value-key="company_id"
								filterable
						>
							<el-option
									v-for="item in cangkuList"
									:key="item.warehouse_id"
									:label="item.name"
									:value="item.warehouse_id"
							></el-option>
						</el-select>
					</div>
				</div>
			</div>
			<div class="information_input" style="margin-bottom:20px;" >
				<div class="information_Title">
					<span class="tips">*</span>
					增值税
				</div>
				<div class="input_el input_span">
					<div class="newipt">
						<el-select
								v-model="formData.vat"
								class="width67 "
								:disabled="system < 5 || isChakan"
								clear
						>
							<el-option
									v-for="item in zengzhiOtions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							></el-option>
						</el-select>
					</div>
				</div>
			</div>
			<div
					class="information_input"
					style="margin-bottom:20px;"
			>
				<div class="information_Title">
					<span class="tips">*</span>
					重量
				</div>
				<div class="input_el input_span">
					<div class="input_bot_tip">
						<el-input v-model="formData.weight"  style="width: 260px" class="danwei_input" oninput ="value=value.replace(/[^0-9.]/g,'')" :disabled="system < 5 || isChakan">
							<el-select slot="append"
									   v-model="formData.weightUnit"
									   placeholder="请选择"
									   :disabled="system < 5 || isChakan"
									   filterable
							>
								<el-option
										v-for="item in danweiOtions"
										:key="item.company_id"
										:label="item.label"
										:value="item.value"
								></el-option>
							</el-select>

						</el-input>
					</div>
				</div>
			</div>
			<div
					class="information_input"
					style="margin-bottom:20px;"
			>
				<div class="information_Title">
					<span class="tips">*</span>
					包裹尺寸
				</div>
				<div class="input_el input_span">
					<div class="input_changkuangao">
						<el-input v-model="formData.width"  style="width: 260px" class="danwei_input" oninput ="value=value.replace(/[^0-9.]/g,'')"
								  :disabled="system < 5 || isChakan">
							<el-select slot="append"
									   v-model="formData.dimensionUnit"
									   placeholder="请选择"
									   filterable
							>
								<el-option
										v-for="item in changOtions"
										:key="item.value"
										:label="item.label"
										:value="item.value"
								></el-option>
							</el-select>

						</el-input>
						<el-input v-model="formData.height"  style="width: 260px;margin-left: 15px" class="danwei_input" oninput ="value=value.replace(/[^0-9.]/g,'')"
								  :disabled="system < 5 || isChakan">
							<el-select slot="append"
									   v-model="formData.dimensionUnit"
									   placeholder="请选择"
									   filterable
							>
								<el-option
										v-for="item in changOtions"
										:key="item.company_id"
										:label="item.label"
										:value="item.value"
								></el-option>
							</el-select>

						</el-input>
						<el-input v-model="formData.depth"  style="width: 260px;margin-left: 15px" class="danwei_input" oninput ="value=value.replace(/[^0-9.]/g,'')"
								  :disabled="system < 5 || isChakan">
							<el-select slot="append"
									   v-model="formData.dimensionUnit"
									   placeholder="请选择"
									   filterable
							>
								<el-option
										v-for="item in changOtions"
										:key="item.company_id"
										:label="item.label"
										:value="item.value"
								></el-option>
							</el-select>

						</el-input>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {ajaxPost, Baseurl} from "../../../../api/api/api";
	export default {
		name: 'wuliuComp',
		props: {
			score: {
				type: Array,
				default() {
					return [0,0,0,0];
				},
			}
		},
		data() {
			return {
				//是否为查看
				isChakan:false,
				system:5,
				formData:{
					//仓库
					warehouseId:'',
					//增值税
					vat:0,
					weight:undefined,
					weightUnit:'g',
					width:undefined,
					height:undefined,
					depth:undefined,
					dimensionUnit:'cm',
					//传int
					zengzhishui:0,
					danwei:'g'
				},
				//卖家id
				sellerId:'',
				cangkuList:[],
				zengzhiOtions:[{label:'无',value:'0'},{label:'10%',value:'0.1'},{label:'20%',value:'0.2'}],
				danweiOtions:[{label:'克',value:'g'},{label:'公斤',value:'kg'},{label:'磅',value:'lb'}],
				changOtions:[{label:'毫米',value:'mm'},{label:'厘米',value:'cm'},{label:'英寸',value:'in'}],

			}
		},
		created() {
			this.cangkuList = []
			this.system = JSON.parse(localStorage.getItem('role')).system
		},
		methods: {
			editCangku(arr){
				this.cangkuList = arr
			},
			getCangku(){
				this.cangkuList = []
				ajaxPost(Baseurl + 'ozonProduct/getOzonWarehouseList', {
					sellerId: this.sellerId
				}).then((res) => {
					const { code, data } = res.data
					if (code == 200) {
						this.cangkuList = data
					}
				})
			},
			selectChange(val){
			},
		}
	}
</script>
<style lang="scss" scoped>
	@import "../ozon.less";
	.input_bot_tip{
		display: flex;
		flex-direction: column;
	}
	.input_changkuangao{
		display: flex;
	}
	.danwei_input{
		/deep/  .el-input-group__append{
			width: 60px !important;
		}
	}
</style>
